import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { spacing } from '../../../atoms/spacing';
import { containers } from '../../../atoms/containers';
import { atMinWidth } from '../../../atoms/breakpoints';

export const headingthemeMap = {
  White: 'light',
  'Midnight/25': 'light',
  'Midnight/50': 'light',
  'DarkBlue/25': 'light',
  'DarkBlue/1000': 'dark',
  Neutral: 'light',
};

export const secondaryButtonVariantMap = {
  White: 'Outline - Blue',
  'Midnight/25': 'Outline - Blue',
  'Midnight/50': 'Outline - Blue',
  'DarkBlue/25': 'Outline - Blue',
  'DarkBlue/1000': 'Outline - White',
  Neutral: 'Outline - Blue',
};

const backgroundColorMap = {
  White: color.common.white,
  'DarkBlue/25': color.darkBlue[25],
  'DarkBlue/1000': color.darkBlue[1000],
  'Midnight/50': color.midnight[50],
  'Midnight/25': color.midnight[25],
  Neutral: color.common.neutral,
};

export const Section = styled.section`
  position: relative;
  width: 100%;
  background: ${props => backgroundColorMap[props.backgroundColor]};
  padding: ${spacing[48]} ${spacing[0]};
  ${atMinWidth.sm`
    padding: ${spacing[72]} ${spacing[0]};
  `}
  ${atMinWidth.xl`
    padding: ${spacing[96]} ${spacing[0]};
  `}
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: ${containers.md};
  display: flex;
  flex-direction: column;
  gap: ${spacing[40]};
  padding: ${spacing[0]} ${spacing[16]};
  margin: ${spacing[0]} auto;
  z-index: 2;
  ${atMinWidth.sm`
    gap: ${spacing[48]};
    padding: ${spacing[0]} ${spacing[32]};
  `}
  ${atMinWidth.xl`
    max-width: ${containers.xl};
  `}
`;

export const Heading = styled.div`
  width: 100%;
  margin: 0px auto;
  .heading-container {
    padding: 0px;
  }
`;

export const CaseStudyHeading = styled.div`
  width: 100%;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  ${atMinWidth.md`
    flex-direction: row;
    justify-content: space-between;
  `}
`;

const gridMappings = {
  1: `grid-template-columns: repeat(1, 1fr);`,
  2: `grid-template-columns: repeat(2, 1fr);`,
  3: `grid-template-columns: repeat(3, 1fr);`,
  4: `grid-template-columns: repeat(4, 1fr);`,
  5: `grid-template-columns: repeat(3, 1fr);`,
  6: `grid-template-columns: repeat(3, 1fr);`,
  7: `grid-template-columns: repeat(4, 1fr);`,
  8: `grid-template-columns: repeat(4, 1fr);`,
  9: `grid-template-columns: repeat(3, 1fr);`,
  10: `grid-template-columns: repeat(4, 1fr);`,
  14: `grid-template-columns: repeat(3, 1fr);`,
};

const gridLayoutMappings = {
  'one-column': `grid-template-columns: repeat(1, 1fr);`,
  'two-column': `grid-template-columns: repeat(2, 1fr);`,
  'three-column': `grid-template-columns: repeat(3, 1fr);`,
  'four-column': `grid-template-columns: repeat(4, 1fr);`,
};

export const Grid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[32]};
  ${atMinWidth.md`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  `}
  ${atMinWidth.xl`
     ${props => {
       if (props.gridlayout) {
         return gridLayoutMappings[props.gridlayout];
       }
       return gridMappings[props.cards];
     }}
  `}
`;
